import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CanActivateViaAuthGuard } from "../../shared/services/auth.service";
import { BulkUploadOnboardingMemberComponent } from "./component/bulk-upload-onboarding-member.component";

const routes = [
  {
    path: "bulk-upload-onloading-member",
    component: BulkUploadOnboardingMemberComponent,
    canActivate: [CanActivateViaAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class BulkUploadOnboardingMemberRoutingModule {}
